<template>
    <div>
      <div class="supplement-step2-content">
        <div class="title">{{$t('message.user.pleaseSelectBusinessType')}}</div>
        <div class="service-type-list">
          <div
            v-for="(item, index) in serviceTypeList"
            :key="index"
            class="service-type-item"
            :class="[
              serviceType === item.value ? 'active' : '',
              getItemCalss(item),
            ]"
            @click="handleServiceType(item.value)">
            {{item.label}}
          </div>
        </div>
      </div>
      <div class="margin-top-20">
      <el-button
        style="width: 100%"
        type="primary"
        @click="onSubmit"
        >{{ $t("message.common.next") }}</el-button>
      </div>
      <custom-message ref="customMessage" cancel-button-text=""></custom-message>
    </div>
</template>

<script>
import CustomMessage from '@/components/modal/message-box/custom-message.vue';

export default {
  components: {
    CustomMessage,
  },
  data() {
    return {
      serviceTypeList: [{
        label: this.$t('message.user.acquiring'),
        value: '1',
      }, {
        label: this.$t('message.user.payout'),
        value: '0',
      }, {
        label: this.$t('message.user.collection'),
        value: '2',
      }],
      serviceType: '0',
      quickRegistrationType: -1, // -1: 不是快速注册  1：快速注册收单  2：快速注册收款
    };
  },
  created() {
    const { type, businessType } = this.$route.query;
    if (`${type}` === '1' && businessType) { // 快速注册
      this.serviceType = businessType;
      this.quickRegistrationType = businessType === '1' ? 1 : 2;
    }
  },
  methods: {
    handleServiceType(value) {
      if (this.quickRegistrationType === 1 && value !== '1') { // 快速注册收单，且当前不是收单选项
        return;
      }
      if (this.quickRegistrationType === 2 && value === '1') { // 快速注册收款，且当前不是收款选项
        return;
      }
      this.serviceType = value;
    },
    onSubmit() {
      if (this.serviceType === '1') { // 暂不支持收单的业务类型
        this.$refs.customMessage.openDefaultModal({
          contentHtml: this.$t('message.user.functionDevelopment'),
          titleHtml: this.$t('message.common.prompt'),
        }, '');
        return;
      }
      this.$emit('finish', this.serviceType);
    },
    getItemCalss(item) {
      if (this.quickRegistrationType === 1 && item.value !== '1') { // 快速注册收单，且当前不是收单选项
        return 'disabled';
      }
      if (this.quickRegistrationType === 2 && item.value === '1') { // 快速注册收款，且当前不是收款选项
        return 'disabled';
      }
      return '';
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/element-variables.scss';
.supplement-step2-content {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 66px;
  margin-bottom: 50px;

  .title {
    color: $color-text-primary;
    font-size: 34px;
    font-weight: 600;
    line-height: 48px;
  }

  .service-type-list {
    display: flex;
    align-items: center;
    margin-top: 37px;

    .service-type-item {
      width: 120px;
      height: 44px;
      background: $color-default;
      border-radius: 22px;
      font-size: 14px;
      font-weight: 600;
      color: $color-text-default-button;
      line-height: 44px;
      text-align: center;
      margin-right: 30px;
      cursor: pointer;

      &.active {
        width: 120px;
        height: 44px;
        background: $color-text-default-button;
        border-radius: 22px;
        color: white;
      }

      &.disabled {
        cursor: not-allowed;
        background: $color-font-disabled;
        color: white;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
